import Link from "next/link";

import styles from "./button-responsive.module.scss";

export default function ButtonResponsive({
  children,
  label,
  shortLabel,
  buttonType,
  href,
  click,
  blank,
  disabled,
}: {
  children?: React.ReactNode | null;
  label: string;
  shortLabel: string;
  buttonType: "primary" | "secondary";
  href?: string;
  click?: () => void;
  blank?: boolean;
  disabled?: boolean;
}) {
  let typeClass;
  switch (buttonType) {
    case "primary":
      typeClass = styles.primary;
      break;
    case "secondary":
      typeClass = styles.secondary;
      break;
    default:
      typeClass = styles.primary;
  }

  const buttonProps = {
    className: `${styles.button_responsive} ${typeClass}`,
  };

  let buttonLabel;
  if (children) {
    buttonLabel = <span>{children}</span>;
  } else if (label && shortLabel) {
    buttonLabel = (
      <>
        <span className={styles.label}>{label}</span>
        <span className={styles.short_label}>{shortLabel}</span>
      </>
    );
  }

  if (href) {
    return (
      <Link href={href} {...buttonProps} target={blank ? "_blank" : "_self"}>
        {buttonLabel}
      </Link>
    );
  } else
    return (
      <button onClick={click} {...buttonProps} disabled={disabled}>
        {buttonLabel}
      </button>
    );
}
